import { Logout, Settings } from "@mui/icons-material";
import {
  Avatar,
  Dialog,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useResetRecoilState, useSetRecoilState } from "recoil";
import Password from "../../pages/User/Dashboard/Profile/Password";
import { getOpportunityByCandidateID } from "../../shared/atom/detailCandidate";
import { authTokenAtom } from "../../shared/globalStates";
import { removeToken } from "../../shared/helpers";
import logo from "./assets/logo-mostrans.png";
import { MenuCandidate } from "./listItems";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  backgroundColor: "#fff",
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(4),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(4),
      },
    }),
  },
}));

function SideBarCandidate() {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/career");
  const [title, setTitle] = useState("Dashboard");
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const resetList = useResetRecoilState(getOpportunityByCandidateID);

  useEffect(() => {
    if (splitLocation[1] === "/home") {
      setTitle("Dashboard");
    } else if (splitLocation[1] === "/joblist") {
      setTitle("Job List");
    } else if (splitLocation[1] === "/assessment") {
      setTitle("Assessment");
    }
  }, [splitLocation]);
  const toggleDrawer = () => {
    setOpen(true);
  };

  const closeToggleDrawer = () => {
    setOpen(false);
  };

  const media = useMediaQuery("(max-width: 550px)");
  const [openPassword, setOpenPassword] = useState(false);
  const setToken = useSetRecoilState(authTokenAtom);

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseDialog = () => {
    setOpenPassword(false);
  };

  const logout = () => {
    resetList();
    localStorage.clear();
    removeToken();
    setToken([]);
    history.push("/");
  };

  const handlePassword = () => {
    setOpenPassword(true);
  };

  return (
    <>
      <Dialog open={openPassword} onClose={handleCloseDialog}>
        <Password open={openPassword} handleClose={handleCloseDialog} />
      </Dialog>
      <AppBar position="absolute" open={open}>
        <Toolbar
          sx={{
            pr: "24px",
            display: open && media && "none",
          }}>
          {open ? null : (
            <Avatar
              src={logo}
              sx={{ width: 50, height: 50, marginLeft: "-35px" }}
            />
          )}
          <Typography
            variant="h4"
            color="primary"
            sx={{ fontWeight: 500, flexGrow: 1, ml: 2 }}>
            {title}
          </Typography>
          <Tooltip title="Account settings">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}>
              <Avatar src={logo} sx={{ width: 50, height: 50 }}></Avatar>
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={openMenu}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{
              horizontal: "right",
              vertical: "top",
            }}
            anchorOrigin={{
              horizontal: "right",
              vertical: "bottom",
            }}>
            <MenuItem component="div" onClick={() => handlePassword()}>
              <ListItemIcon>
                <Settings fontSize="small" />
              </ListItemIcon>
              Ganti Password
            </MenuItem>
            <Divider />
            <MenuItem onClick={() => logout()}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        open={open}
        onMouseEnter={toggleDrawer}
        onMouseLeave={closeToggleDrawer}>
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            px: [1],
          }}>
          <Avatar
            src={logo}
            sx={{ width: 50, height: 50, marginRight: "15px" }}
          />
          <Typography variant="h6" color="#07784A" sx={{ flexGrow: 1 }}>
            Mostrans Career
          </Typography>
        </Toolbar>
        <List component="nav">
          <MenuCandidate />
        </List>
      </Drawer>
    </>
  );
}

export default SideBarCandidate;
